<template>
  <div>
    <carousel-3d :display="display" :controls-visible="true" height="251">
      <slide v-for="(video, index) in fetchVideos" :index="index" :key="index">
        <slot :video="video" name="slide-card"></slot>
      </slide>
    </carousel-3d>
  </div>
</template>

<script>
  import slider from '@fremcast/section/mixins/slider3D';
  import section from '@fremcast/section/mixins/section';
  import video from '@fremcast/section/mixins/videos';
  export default {
    mixins: [
      slider,
      section,
      video
    ]
  }
</script>

<style scoped>
  .video-card {
    margin-left: 10px;
  }

  img {
    height: 130px;
    object-fit: cover;
  }

  .carousel-3d-container {
    margin: 0;
  }

  .carousel-3d-slide {
    /*
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid rgba(0,0,0,0.08);
    box-shadow: 0px 3px 8px rgba(0,0,0, 0.06);
    */
    background-color: inherit;
    border-radius: 0;
    border-color: inherit;
    border-style: none;
  }
</style>
